import { useSelector } from 'react-redux';

import { useLocale } from '../../../../intl/hooks';
import { getLink } from '../../../../services/link-service';
import Global from '../../../../store/global-selectors';

/**
 * Given the LinkID of a support page this hooks returns the full URL
 * @param {string} linkId
 * @returns {string} The full URL link
 */
export const useSupportLink = (linkId) => {
  const intl = useLocale();
  const supportCountry = useSelector((state) => Global.selectSellerSupportCountry(state));
  const link = getLink(linkId, supportCountry, intl.locale);

  return link;
};
